export enum BookingStatusEnum {
  ABSENT = 'ABSENT',
  ATTENDED = 'ATTENDED',
  MANAGED = 'MANAGED',
  BOOKED = 'BOOKED',
  EMPTY = 'EMPTY',
}
